const Messages = {
    default: "Please fill out this field.",
    required: "This field is required.",
    checkbox: "Please select at least one option.",
    email: "Please enter a valid email address.",
    radio: "Please select an option.",
    select: "Please select an option.",
    numeric: "Please enter a number.",
};

const SetMessageContainer = (element) => {
    if (element.tagName.toLowerCase() === "input") {
        if (element.type === "checkbox") {
            return element.nextElementSibling;
        } else if (element.type === "radio") {
            return element.parentElement.parentElement.parentElement;
        }
    }

    return element.closest("div");
};

const InvalidFieldEventHandler = (fv, fieldName) => {
    const fields = fv.getElements(fieldName);
    if (fields.length === 0) {
        return;
    }

    for (let i = 0; i < fields.length; i += 1) {
        fields[i].classList.add("error");

        if (fields[i].name === "dob") {
            fields[i].parentElement.classList.add("error");
        }
    }
};

const ValidFieldEventHandler = (fv, fieldName) => {
    const fields = fv.getElements(fieldName);
    if (fields.length === 0) {
        return;
    }

    for (let i = 0; i < fields.length; i += 1) {
        fields[i].classList.remove("error");

        if (fields[i].name === "dob") {
            fields[i].parentElement.classList.remove("error");
        }
    }
};

const DobValidators = {
    notEmpty: {
        message: Messages.default,
    },
    date: {
        format: "YYYY/MM/DD",
        message: "Please enter a valid date.",
    },
    callback: {
        message: "We only accept egg donors aged between 18 and 35.",
        callback: function (input) {
            const age =
                new Date(new Date() - new Date(input.value)).getFullYear() -
                1970;

            if (age < 18 || age > 35) {
                return false;
            }
            return true;
        },
    },
};

const ValidateDob = (form, fv) => {
    const keyupHandler = () => {
        const y = year.value;
        const m = month.value;
        const d = day.value;

        // Set the dob field value
        const dob = y === "" || m === "" || d === "" ? "" : [y, m, d].join("/");
        form.querySelector('[name="dob"]').value = dob;

        // Revalidate it
        fv.revalidateField("dob");
    };

    const day = form.querySelector('[name="date_of_birth_0"]');
    const month = form.querySelector('[name="date_of_birth_1"]');
    const year = form.querySelector('[name="date_of_birth_2"]');

    day.addEventListener("keyup", keyupHandler);
    month.addEventListener("keyup", keyupHandler);
    year.addEventListener("keyup", keyupHandler);
};

export {
    DobValidators,
    ValidateDob,
    Messages,
    SetMessageContainer,
    InvalidFieldEventHandler,
    ValidFieldEventHandler,
};
